/* Polsk katalog for locale-no.js (del 7 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'bg.balanceDiscrepancy': 'Różnica salda',
  'bg.notCorrect': 'Niepoprawne',
  'bg.reconciliationDone': 'Uzgodnienie bankowe zostało zakończone',
  'bg.reconciliationDoneHelp': 'Wyciąg został sprawdzony, zaksięgowany i przeniesiony do archiwum.',
  'bg.bankLines': 'Linie bankowe',
  'bg.reconciled': 'Uzgodniono',
  'bg.backToBank': 'Wróć do Banku',
  'bg.reopenReconciliation': 'Otwórz uzgodnienie ponownie',
  'bg.bankAccountCaps': 'RACHUNEK BANKOWY',
  'bg.periodCaps': 'OKRES',
  'bg.balanceAtStart': 'Saldo na początek okresu',
  'bg.balanceAtEnd': 'Saldo na koniec okresu',
  'bg.balancesMatch': 'Salda się zgadzają.',
  'bg.roundingHelp': 'Można to zaksięgować na konto zaokrągleń 7770 bez zmiany kwoty z wyciągu bankowego.',
  'bg.balancesMatchContinue': 'Salda się zgadzają – dalej',
  'bg.suggestionsHeading': 'SuperPlumma dopasowała i zaproponowała księgowania — Ty decydujesz',
  'bg.noSuggestions': 'Żadne propozycje nie czekają na zatwierdzenie.',
  'bg.continueToRest': 'Przejdź do pozostałych',
  'bg.noPostedDiscrepancies': 'Żadne zaksięgowane pozycje nie powodują różnic.',
  'bg.checkAndFix': 'Sprawdź i popraw pozycje przed zakończeniem okresu.',
  'bg.allPaymentsHandled': 'Wszystkie płatności zostały obsłużone.',
  'bg.continueToVouchers': 'Przejdź do dokumentów',
  'bg.allPurchasesDocumented': 'Wszystkie zakupy mają wymaganą dokumentację lub są oznaczone jako bez dokumentu.',
  'bg.seePurchase': 'Zobacz zakup',
  'bg.withoutVoucher': 'Bez dokumentu',
  'bg.linkSuggested': 'Powiąż propozycję',
  'bg.pickVoucher': 'Wybierz dokument',
  'bg.continueToFinish': 'Przejdź do zakończenia',
  'bg.bankLinesTotal': 'Linie bankowe łącznie',
  'bg.linkedPosted': 'Powiązane/zaksięgowane',
  'bg.privateMovements': 'Ruchy prywatne',
  'bg.reconcileAndArchive': 'Uzgodnij i zarchiwizuj',
  'bg.backAndCheck': 'Wróć i sprawdź',
  'bg.stepModeHelp': 'Tryb krok po kroku prowadzi przez jedno zadanie naraz. Pełny widok pokazuje wszystko razem.',
  'acc.sub': 'Twój profil i firmy, do których masz dostęp.',
  'acc.signOutHelp': 'Wylogowuje Cię z Plumme. Aby kontynuować, musisz zalogować się ponownie e-mailem i hasłem.',
  'acc.yourRole': 'Twoja rola',
  'acc.yourRoleHelp': 'Rola określa, co możesz robić: Właściciel ma pełny dostęp, Administrator zarządza działaniem, Księgowy prowadzi księgi, a Czytelnik może tylko przeglądać. Rola może być różna w różnych firmach.',
  'acc.editProfile': 'Edytuj profil',
  'acc.myBusinesses': 'Moje firmy',
  'acc.myBusinessesHelp': 'Firmy, do których masz dostęp w Plumme. Etykieta pokazuje Twoją rolę w każdej z nich. Dotknij firmy, aby otworzyć jej księgi.',
  'acc.personalFinanceHelp': 'Finanse osobiste to osobny typ klienta dla finansów osobistych i domowych, oddzielony od księgowości firm.',
  'acc.goToPersonalFinance': 'Przejdź do finansów osobistych',
  'acc.ownPersonalClient': 'Własny klient Finansów osobistych',
  'acc.myEmployers': 'Moi pracodawcy',
  'acc.myEmployersHelp': 'Firmy, w których jesteś zatrudniony (niekoniecznie prowadzisz ich księgi). Z czasem znajdziesz tu paski wynagrodzeń, umowy i własną stronę pracownika.',
  'acc.employerPortalAccess': 'Firmy, do których masz dostęp w portalu pracownika.',
  'acc.changePicture': 'Zmień zdjęcie',
  'acc.removePicture': 'Usuń zdjęcie',
  'acc.photoUploading': 'Przesyłanie …',
  'acc.photoRemoving': 'Usuwanie …',
  'acc.photoSaved': 'Zdjęcie profilowe zostało zaktualizowane.',
  'acc.photoRemoved': 'Zdjęcie profilowe zostało usunięte.',
  'acc.photoWrongType': 'Wybierz obraz w formacie PNG, JPG lub WebP.',
  'acc.photoEmpty': 'Plik obrazu jest pusty.',
  'acc.photoTooLarge': 'Obraz jest za duży. Maks. 2 MB.',
  'acc.photoUploadFailed': 'Nie udało się przesłać zdjęcia profilowego.',
  'acc.photoRemoveFailed': 'Nie udało się usunąć zdjęcia profilowego.',
  'acc.photoUnavailable': 'Zdjęcie profilowe jest w tej chwili niedostępne.',
  'acc.fullName': 'Imię i nazwisko',
  'acc.phoneFromLogin': 'Telefon z logowania',
  'acc.changePassword': 'Zmień hasło',
  'acc.changes': 'Zmiany',
  'acc.noChangeDetails': 'Dla tego zdarzenia nie zapisano dodatkowych szczegółów zmian.',
  'acc.logSub': 'Co zrobiono w księgowości - i przez kogo.',
  'acc.logFilterHelp': 'Filtruj dziennik według okresu, obszaru (np. Faktura, Płace, VAT) i użytkownika, który wykonał działanie.',
  'acc.area': 'Obszar',
  'acc.areaHelp': 'Której części księgowości dotyczy działanie - np. Faktura, Zakup, Płace lub VAT. Jedno działanie może dotyczyć kilku obszarów.',
  'acc.user': 'Użytkownik',
  'acc.userHelp': 'Osoba, która wykonała działanie, wraz z jej rolą. Dzięki temu widzisz, kto stoi za każdą zmianą.',
  'acc.sentLinkTo': 'Wysłaliśmy link na adres',
  'bud.annualBudget': 'Budżet roczny',
  'bud.suggestion': 'Propozycja budżetu',
  'bud.createSuggestion': 'Utwórz propozycję',
  'bud.startSimpleQuestions': 'Zacznij od prostych pytań',
  'bud.fillRelevant': 'Wypełnij tylko to, co istotne. Kwoty miesięczne zostaną przeliczone na budżet roczny.',
  'bud.businessDescription': 'Opis działalności',
  'bud.businessDescriptionPh': 'Np. firma transportowa na 2027 z 2 samochodami dostawczymi, 2 pracownikami, czynszem za biuro 8 000/mies. i wyższymi przychodami latem.',
  'bud.howToBudget': 'Jak przygotować budżet',
  'bud.howToBudgetHelp': 'Wybierz metodę: w trybie „Ręcznie” sam wprowadzasz konta, w trybie „Propozycja” odpowiadasz na kilka prostych pytań i otrzymujesz szkic, a w trybie „Propozycja AI” opisujesz działalność własnymi słowami, a Plumme tworzy szkic.',
  'bud.budgetedResult': 'Budżetowany wynik',
  'bud.budgetedResultHelp': 'Wynik zabudżetowany na cały rok — budżetowane przychody minus budżetowane koszty. To cel, do którego zmierzasz.',
  'bud.actualResult': 'Faktyczny wynik',
  'bud.actualResultHelp': 'Faktyczny wynik zaksięgowany od początku roku — rzeczywiste przychody minus rzeczywiste koszty. Porównaj go z budżetem, aby sprawdzić, czy realizujesz plan.',
  'bud.postedSoFar': 'zaksięgowano dotąd',
  'bud.varianceToPeriod': 'Odchylenie w okresie',
  'bud.varianceToPeriodHelp': 'Różnica między faktycznym a budżetowanym wynikiem do tej pory. Ujemne odchylenie oznacza, że jesteś poniżej budżetu, dodatnie – że powyżej.',
  'bud.incomeTarget': 'Cel przychodowy',
  'bud.incomeTargetHelp': 'Jaką część budżetowanych przychodów roku osiągnąłeś do tej pory — faktycznie zafakturowane przychody podzielone przez budżetowane przychody.',
  'bud.ofTargetReached': 'celu osiągnięto',
  'bud.viewHelp': 'Zmień widok: „Przegląd” pokazuje skumulowany wynik i największe odchylenie, „Analiza” pokazuje przychody wobec kosztów i wynik w poszczególnych miesiącach, a w „Budżet według kategorii” wprowadzasz i zmieniasz kwoty.',
  'bud.accumulatedResult': 'Skumulowany wynik',
  'bud.accumulatedResultHelp': 'Wykres pokazuje, jak wynik narasta miesiąc po miesiącu w ciągu roku. Linia przerywana to budżet, ciągła to faktycznie zaksięgowane kwoty — dzięki temu widzisz, czy realizujesz plan.',
  'bud.budgetAtYearEnd': 'Budżet na koniec roku',
  'bud.accumulated': 'narastająco',
  'bud.actualSoFar': 'Faktycznie dotąd',
  'bud.posted': 'zaksięgowano',
  'bud.varianceSoFar': 'Odchylenie do tej pory',
  'bud.largestVariance': 'Największe odchylenie',
  'bud.largestVarianceHelp': 'Konto, które od początku roku najbardziej odbiega od budżetu. Przydatne, aby szybko zobaczyć, gdzie najbardziej przekraczasz plan lub jesteś poniżej niego.',
  'bud.soFarThisYear': 'od początku roku',
  'bud.incomeVsCost': 'Przychody a koszty w miesiącach',
  'bud.incomeVsCostHelp': 'Słupki pokazują przychody (zielone) w porównaniu z kosztami (pomarańczowe) w każdym miesiącu. Przełączaj między danymi rzeczywistymi, budżetowymi lub obydwoma. Dotknij miesiąca, aby zsumować wybór.',
  'bud.resultPerMonth': 'Wynik w miesiącach',
  'bud.resultPerMonthHelp': 'Pokazuje wynik (przychody minus koszty) dla każdego miesiąca, budżet w porównaniu z rzeczywistością. Słupki nad linią środkową to zysk, pod nią strata.',
  'bud.actual': 'Rzeczywiste',
  'bud.actualByCategory': 'Rzeczywiste według kategorii',
  'bud.actualByCategoryHelp': 'Zaksięgowane przychody i koszty według konta, w podziale na miesiące. Dane pochodzą z Twoich ksiąg — zarówno z dokumentów zarejestrowanych w Plumme, jak i z importu — i aktualizują się automatycznie.',
  'bud.noActuals': 'Brak zaksięgowanych danych za {year}.',
  'bud.actualOnlyHint': 'To są dane rzeczywiste. Dodaj budżet w sekcji Budżet, jeśli chcesz porównywać się z planem.',
  'bud.byCategory': 'Budżet według kategorii',
  'bud.addIncome': 'Dodaj przychód',
  'bud.addIncomeHelp': 'Dodaj kategorię przychodów z kwotą roczną — np. oczekiwaną sprzedaż. Kwota zostanie rozłożona na miesiące, co możesz dostosować.',
  'bud.addCost': 'Dodaj koszt',
  'bud.addCostHelp': 'Dodaj kategorię kosztów z kwotą roczną — np. czynsz, zakup towarów lub oprogramowanie. Kwota zostanie rozłożona na miesiące, co możesz dostosować.',
  'bud.noCategories': 'Brak kategorii budżetu. Dodaj przychód lub koszt.',
  'bud.useLastYear': 'Użyj zeszłego roku',
  'bud.simpleQuestions': 'Proste pytania',
  'bud.byCategoryHelp': 'Każdy wiersz to kategoria budżetu. Kwoty dla wszystkich 12 miesięcy są zawsze widoczne i edytowalne bezpośrednio w tabeli, a suma roczna jest po prawej.',
  'bud.total': 'Suma',
  'bud.annualTotal': 'Suma roczna',
  'bud.annualTotalHelp': 'Jeśli zmienisz tę liczbę bezpośrednio, nowa kwota roczna zostanie równomiernie rozłożona na wszystkie 12 miesięcy.',
  'bud.save': 'Zapisz',
  'bud.methodManual': 'Ręcznie',
  'bud.methodSuggestion': 'Propozycja',
  'bud.methodAi': 'Propozycja AI',
  'bud.modeBudgeted': 'Budżetowe',
  'bud.modeBoth': 'Oba',
  'bud.forWholeYear': 'za cały {year}',
  'bud.underBudget': 'poniżej budżetu',
  'bud.overBudget': 'powyżej budżetu',
  'bud.legendBudgetDashed': '- - Budżet',
  'bud.legendBudgetSolid': '— Budżet',
  'bud.legendActual': '— Rzeczywiste',
  'bud.noVarianceYet': 'Brak odchyleń',
  'bud.savedToast': 'Budżet zapisany',
  'bud.saveFailedToast': 'Nie udało się zapisać budżetu',
  'bud.aiModalTitle': 'Budżet AI na {year}',
  'bud.aiDraftBusy': 'Tworzenie szkicu...',
  'bud.aiDraftCreate': 'Utwórz szkic z AI',
  'bud.aiDescription': 'Opisz firmę własnymi słowami: pracownicy, wynagrodzenia, aktywa, koszty stałe i sezonowość. Im więcej szczegółów, tym lepszy szkic.',
  'bud.aiDraftFailedGeneric': 'Nie udało mi się utworzyć szkicu budżetu z opisu. Dodaj więcej szczegółów lub użyj opcji Propozycja.',
  'bud.aiDraftAppliedToast': 'Szkic AI został wstawiony. Naciśnij Zapisz, gdy będzie wyglądał dobrze.',
  'bud.aiDraftFailed': 'Nie udało się utworzyć szkicu budżetu AI.',
  'bud.suggestionIntro': 'Utwórz propozycję na podstawie rzeczywistych danych z zeszłego roku lub odpowiedz na kilka prostych pytań, aby uzyskać budżet startowy.',
  'bud.catSales': 'Sprzedaż towarów i usług',
  'bud.catPurchases': 'Zakup towarów i koszty bezpośrednie',
  'bud.catPremises': 'Lokale',
  'bud.catSoftware': 'Oprogramowanie i sprzęt',
  'bud.catAccounting': 'Księgowość i doradztwo',
  'bud.catTravel': 'Podróże',
  'bud.catMarketing': 'Marketing',
  'bud.catCommunication': 'Telefon, poczta i komunikacja',
  'bud.otherCosts': 'Pozostałe koszty',
  'bud.customCategory': 'Własna kategoria',
  'bud.q.expectedIncome.label': 'Ile chcesz zarobić?',
  'bud.q.expectedIncome.hint': 'Oczekiwany zafakturowany przychód za cały rok.',
  'bud.q.goodsAnnual.label': 'Zakup towarów',
  'bud.q.goodsAnnual.hint': 'Towary lub materiały kupowane do odsprzedaży.',
  'bud.q.officeMonthly.label': 'Biuro/lokal miesięcznie',
  'bud.q.officeMonthly.hint': 'Czynsz, przestrzeń biurowa lub lokal.',
  'bud.q.softwareMonthly.label': 'Oprogramowanie miesięcznie',
  'bud.q.softwareMonthly.hint': 'Subskrypcje, narzędzia i aplikacje.',
  'bud.q.accountingMonthly.label': 'Księgowość/doradztwo miesięcznie',
  'bud.q.accountingMonthly.hint': 'Księgowy, doradca lub inna pomoc.',
  'bud.q.travelAnnual.label': 'Samochód/podróże rocznie',
  'bud.q.travelAnnual.hint': 'Jazdy, podróże, hotele lub transport.',
  'bud.q.marketingAnnual.label': 'Marketing rocznie',
  'bud.q.marketingAnnual.hint': 'Reklamy, promocja marki i koszty sprzedaży.',
  'bud.q.otherAnnual.hint': 'Dodaj rezerwę na to, czego jeszcze nie wiesz.',
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Zapytaj SuperPlumma',
  'aii.chatWithSuperPlumma': 'Czat z SuperPlumma',
  'aii.chatWithMe': 'Porozmawiaj ze mną',
  'aii.healthScore': 'Wskaźnik kondycji finansowej',
  'po.title': 'Finanse osobiste',
  'po.backToBusiness': 'Wróć do firmy',
  'po.yourAdvisor': 'Twój osobisty doradca',
  'po.intro': 'Finanse osobiste to Twoje prywatne finanse — całkowicie oddzielone od księgowości firmy. SuperPlumma analizuje dochody, wydatki, oszczędności, kredyty, emeryturę i podatki gospodarstwa domowego oraz doradza tak, jak zrobiłby to osobisty doradca finansowy. „Beta” oznacza, że funkcja jest wciąż rozwijana.',
  'po.hero.greeting.night': 'Dobranoc.',
  'po.hero.greeting.morning': 'Dzień dobry.',
  'po.hero.greeting.day': 'Cześć.',
  'po.hero.greeting.evening': 'Dobry wieczór.',
  'po.hero.greetingNamed.night': 'Dobranoc, {name}.',
  'po.hero.greetingNamed.morning': 'Dzień dobry, {name}.',
  'po.hero.greetingNamed.day': 'Cześć, {name}.',
  'po.hero.greetingNamed.evening': 'Dobry wieczór, {name}.',
  'po.hero.section.idag': 'Porada dnia',
  'po.hero.section.oversikt': 'Przegląd finansów',
  'po.hero.section.forbruk': 'Wydatki',
  'po.hero.section.familie': 'Finanse rodzinne',
  'po.hero.section.fremtid': 'Plan na przyszłość',
  'po.hero.section.reports': 'Raporty',
  'po.hero.section.assets': 'Aktywa',
  'po.hero.section.gjeld': 'Zadłużenie',
  'po.hero.section.import': 'Źródło danych',
  'po.hero.advice.idag': 'Śledzę Twoje finanse i wskazuję najważniejsze zadania i możliwości w tej chwili.',
  'po.hero.advice.oversikt': 'Zobacz, co podnosi, a co obniża Twoją kondycję finansową. Zacznij od obszaru, który wymaga najwięcej uwagi.',
  'po.hero.advice.forbruk': 'Poszukaj kategorii, które wzrosły, i wybierz jeden realistyczny krok, który da więcej przestrzeni bez nadmiernego zaciskania pasa.',
  'po.hero.advice.familie': 'Ustal, co jest wspólne, kto za co płaci i jakie cele gospodarstwo domowe ma wspólnie traktować priorytetowo.',
  'po.hero.advice.fremtid': 'Skonkretyzuj cele kwotą i datą. Łatwiej wtedy zobaczyć, ile odkładać co miesiąc.',
  'po.hero.advice.reports': 'Korzystaj z raportów, aby zrozumieć zmiany w czasie, a nie tylko pojedynczy wysoki lub niski miesiąc.',
  'po.hero.advice.assets': 'Sprawdź, czy wartości i salda kont są aktualne, zanim ocenisz majątek netto i decyzje długoterminowe.',
  'po.hero.advice.gjeld': 'Najpierw zbuduj bezpieczną rezerwę, a potem rozważ dodatkowe spłaty zadłużenia o najwyższym oprocentowaniu efektywnym.',
  'po.hero.advice.import': 'Dobra rada zaczyna się od dobrych danych. Powiąż wyciągi z właściwym kontem i uzupełnij brakujące okresy.',
  'po.pickPerson': 'Wybierz osobę',
  'po.sections': 'Sekcje',
  'po.sectionsHelp': 'Przełączaj się między obszarami: Dziś (dzisiejsze spostrzeżenia), Przegląd (wskaźnik kondycji i kluczowe dane), Wydatki (na co idą pieniądze), Rodzina, Przyszłość (prognoza i „co jeśli”), Raporty, Aktywa, Zadłużenie, Podatki i Import.',
  'po.outOf100': 'na 100',
  'po.todaysFocus': 'Dzisiejszy priorytet',
  'po.todaysTasks': 'Dzisiejsze zadania',
  'po.mostImportantToday': 'Najważniejsze dzisiaj',
  'po.markDone': 'Oznacz jako wykonane',
  'po.undo': 'Cofnij',
  'po.healthHeading': 'Twoja ogólna kondycja finansowa — i co na nią wpływa',
  'po.healthHelp': 'Liczba w pierścieniu (0–100) to ogólna ocena twoich finansów — im wyższa, tym zdrowiej. Kategorie poniżej pokazują, co ją podnosi i obniża: zielony jest dobry, żółty oznacza, że warto obserwować, a czerwony wymaga działania.',
  'po.noHistory': 'Brak historii do porównania',
  'po.whatAffectsScore': 'Co najbardziej wpływa na wynik',
  'po.noDrivers': 'Nie obliczono jeszcze czynników',
  'po.noDriversHelp': 'Gdy będzie wystarczająco dużo zaimportowanych transakcji, pokażę, co podnosi i obniża wynik.',
  'po.last30Days': 'Ostatni zarejestrowany miesiąc',
  'po.last30DaysSub': 'W porównaniu z poprzednim miesiącem kalendarzowym',
  'po.financialOverview': 'Przegląd finansowy',
  'po.financialOverviewSub': 'Migawka finansów gospodarstwa domowego',
  'po.recommendations': 'Rekomendacje SuperPlummy',
  'po.recommendationsSub': 'Kroki, które w tej chwili najbardziej liczą się dla twoich finansów',
  'po.askMe': 'Zapytaj mnie',
  'po.yourHealthScoreIs': 'Twój wynik kondycji to',
  'po.adjustBudget': 'Dostosuj budżet',
  'po.budgetTotal': 'Suma budżetu:',
  'po.saveBudget': 'Zapisz budżet',
  'po.monthlyLimitPerCategory': 'Miesięczny limit na kategorię',
  'po.noCategoriesImported': 'Nie zaimportowano jeszcze kategorii wydatków. Dodaj własne kategorie poniżej.',
  'po.ownCategories': 'Własne kategorie',
  'po.pickColour': 'Wybierz kolor',
  'po.categoryName': 'Nazwa kategorii',
  'po.removeCategory': 'Usuń kategorię',
  'po.addCategory': 'Dodaj kategorię',
  'po.budgetVsSpending': 'Budżet a wydatki',
  'po.budgetVsSpendingSub': 'Miesięczny limit w porównaniu z wydatkami w wybranym okresie',
  'po.budgetVsSpendingHelp': 'Miesięczny budżet w porównaniu z faktycznymi wydatkami na kategorię. Naciśnij „Dostosuj budżet”, aby ustawić limity lub utworzyć własne kategorie. Pasek postępu wypełnia się według tego, ile budżetu wykorzystano — zielony oznacza w limicie, żółty zbliżanie się do limitu, a czerwony przekroczenie kategorii. Jeśli wybierzesz przegląd roczny, miesięczny limit jest mnożony przez liczbę miesięcy z zaimportowanymi danymi. Budżety są zapisywane dla wybranego roku.',
  'po.whereMoneyGoes': 'Na co idą pieniądze?',
  'po.whereMoneyGoesSub': 'Dotknij kategorii, aby zobaczyć transakcje i przenieść je we właściwe miejsce',
  'po.whereMoneyGoesHelp': 'Wykres kołowy i lista pokazują wydatki według kategorii w wybranym okresie. Zmień okres przyciskiem u góry — miesiące bez zaimportowanych transakcji są wyszarzone. Dotknij kategorii, aby ją wyróżnić. Procent po prawej to zmiana względem poprzedniego miesiąca — zielony w dół oznacza mniej, czerwony w górę oznacza więcej.',
  'po.selectPeriod': 'Wybierz okres',
  'po.yearOverview': 'Przegląd roczny',
  'po.yearly': 'Rocznie',
  'po.month.1': 'Styczeń',
  'po.month.2': 'Luty',
  'po.month.3': 'Marzec',
  'po.month.4': 'Kwiecień',
  'po.month.5': 'Maj',
  'po.month.6': 'Czerwiec',
  'po.month.7': 'Lipiec',
  'po.month.8': 'Sierpień',
  'po.month.9': 'Wrzesień',
  'po.month.10': 'Październik',
  'po.month.11': 'Listopad',
  'po.month.12': 'Grudzień',
  'po.largestCategoryIs': 'Największa kategoria kosztów to',
  'po.recurringCharges': 'Stałe obciążenia do sprawdzenia',
  'po.recurringChargesSub': 'Cykliczne opłaty za subskrypcje, które warto sprawdzić',
  'po.opportunity': 'Możliwość',
  'po.estimatedAnnualCost': 'Szacowany koszt roczny',
  'po.saveAccount': 'Zapisz konto',
  'po.allAccounts': 'Wszystkie konta',
  'po.uploadedStatements': 'Przesłane wyciągi',
  'po.yourAccounts': 'Twoje konta',
  'po.yourAccountsSub': 'Rejestruj i sortuj konta według typu — zaimportowane wyciągi są przypisywane do właściwego konta',
  'po.totalBalance': 'Łączne saldo',
  'po.creditDebt': 'Zadłużenie na karcie kredytowej',
  'po.accounts': 'Konta',
  'po.analysis': 'Analiza SuperPlummy',
  'po.analysisSub': 'Jak rozkładają się wydatki w kategorii — i co możesz zrobić',
  'po.whoIsBehind': 'Kto za tym stoi',
  'po.noTransactionsToAnalyse': 'Brak transakcji do analizy.',
  'po.unusualPurchases': 'Nietypowe zakupy',
  'po.noUnusualPurchases': 'W tym okresie żaden zakup się nie wyróżnia.',
  'po.searchTransactions': 'Szukaj transakcji …',
  'po.clearSearch': 'Wyczyść wyszukiwanie',
  'po.sort': 'Sortuj',
  'po.linkStatementToAccount': 'Powiąż wyciąg z kontem',
  'po.linkToAccount': 'Powiąż z kontem',
  'po.newAccount': 'Nowe konto',
  'po.accountNamePh': 'Np. DNB konto bieżące',
  'po.accountNumberPh': 'Np. 1234.56.78901',
  'po.currentAccount': 'Konto bieżące',
  'po.creditCard': 'Karta kredytowa',
  'po.me': 'ja',
  'po.importTitle': 'Importuj dane finansowe',
  'po.importSub': 'Prześlij wyciągi bankowe — SuperPlumma automatycznie je odczyta i skategoryzuje',
  'po.pickStatement': 'Wybierz wyciąg z banku',
  'po.pickStatementHelp': 'Prześlij wyciągi ze swojego banku. XLSX i CSV są odczytywane bezpośrednio, PDF odczytywany jest z tekstu w miarę możliwości. SuperPlumma automatycznie kategoryzuje transakcje.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Nie przesłano jeszcze żadnych wyciągów bankowych.',
  'po.deleteStatement': 'Usuń wyciąg',
  'po.sharedCosts': 'Udział we wspólnych kosztach',
  'po.sharedCostsSub': 'Kto płaci za co ze wspólnych wydatków — i jak to wygląda na tle udziału w dochodach',
  'po.sharedCostsHelp': 'Słupek pokazuje, jaką część wspólnych kosztów gospodarstwa domowego pokrywa każde z was. Po prawej znajduje się udział w łącznym dochodzie. Jeśli oba są równe, podział jest proporcjonalny do dochodu. Dane pochodzą z tego, co każde z was wpisało we własnym profilu.',
  'po.splitIsEven': 'Podział jest równy. Dzielicie',
  'po.togetherYouCan': 'Razem możecie',
  'po.togetherYouCanSub': 'Małe kroki, które możecie podjąć jako zespół — wyliczone z danych gospodarstwa domowego',
  'po.togetherHelp': 'Propozycje są wyliczone na podstawie łącznego dochodu i wspólnych kosztów, które wpisaliście. Są pomyślane jako wspólne cele, a nie wymagania wobec poszczególnych osób.',
  'po.sharedSteps': 'Wspólne kroki',
  'po.magnitude': 'Rząd wielkości',
  'po.youPartnerPh': 'Ty, partner …',
  'po.monthlyNetIncome': 'Miesięczny dochód netto',
  'po.sharedCostShare': 'Udział we wspólnych kosztach miesięcznie',
  'po.familyFinances': 'Finanse rodzinne',
  'po.addPerson': 'Dodaj osobę',
  'po.noHouseholdMembers': 'Nie zarejestrowano jeszcze członków gospodarstwa domowego.',
  'po.householdHasRegistered': 'Gospodarstwo domowe zarejestrowało',
  'po.todaysPlan': 'Plan na dziś',
  'po.savePlan': 'Zapisz plan',
  'po.monthlySaving': 'Miesięczne oszczędności (NOK)',
  'po.monthlyExtraDebt': 'Miesięczna dodatkowa spłata długu (NOK)',
  'po.targetNetWealth': 'Docelowy majątek netto (NOK)',
  'po.expectedReturn': 'Oczekiwana roczna stopa zwrotu (%)',
  'po.yourAgeToday': 'Twój obecny wiek (lata)',
  'po.desiredRetirementAge': 'Docelowy wiek emerytalny (lata)',
  'po.pickEvent': 'Wybierz zdarzenie',
  'po.eventNamePh': 'Np. Drugie dziecko',
  'po.starts': 'Początek',
  'po.oneOffCost': 'Koszt jednorazowy (NOK)',
  'po.monthlyEffect': 'Efekt miesięczny (NOK)',
  'po.durationMonths': 'Czas trwania (miesiące)',
  'po.goalName': 'Nazwa celu',
  'po.goalNamePh': 'Np. Poduszka finansowa',
  'po.shortDescription': 'Krótki opis',
  'po.whatSavingFor': 'Na co oszczędzasz?',
  'po.targetAmount': 'Kwota docelowa (NOK)',
  'po.savedSoFar': 'Dotychczas zaoszczędzono (NOK)',
  'po.icon': 'Ikona',
  'po.colour': 'Kolor',
  'po.debtFree': 'Bez długów',
  'po.saveLoan': 'Zapisz kredyt',
  'po.loanType': 'Rodzaj kredytu',
  'po.spendingCategory': 'Kategoria w Wydatkach',
  'po.categoryPh': 'Np. Mieszkanie',
  'po.debtOverview': 'Przegląd zadłużenia',
  'po.debtOverviewSub': 'Wszystkie twoje kredyty razem — pozostały dług, odsetki i tempo spłaty',
  'po.debtOverviewHelp': 'Kluczowe wskaźniki całego zadłużenia: łączny pozostały dług, ile spłacasz miesięcznie, koszty odsetek rocznie, średnie oprocentowanie i ile czasu zostało do spłaty wszystkich długów.',
  'po.totalDebt': 'Łączne zadłużenie',
  'po.repaymentPerMonth': 'Spłata miesięcznie',
  'po.interestPerYear': 'Odsetki rocznie',
  'po.averageRate': 'Średnie oprocentowanie',
  'po.debtFreeIn': 'Bez długów za',
  'po.loanCount': 'Liczba kredytów',
  'po.yourLoans': 'Twoje kredyty',
  'po.yourLoansSub': 'Dotknij kredytu, aby zobaczyć harmonogram spłat i symulować zmiany',
  'po.addLoan': 'Dodaj kredyt',
  'po.noLoans': 'Nie dodano jeszcze żadnych kredytów. Naciśnij „Dodaj kredyt”, aby zacząć.',
  'po.whichLoanFirst': 'Które kredyty spłacić najpierw?',
  'po.whichLoanFirstSub': 'Uszeregowane według oprocentowania — najdroższy kredyt najpierw daje najwięcej za każdą dodatkową koronę',
  'po.iRecommend': 'Polecam',
  'po.snowballWithRate': 'metodę oprocentowania (metodę lawiny)',
  'po.repaymentSimSub': 'Zobacz, jak spada pozostały dług, i symuluj, co się stanie, jeśli będziesz płacić więcej lub mniej miesięcznie',
  'po.myRecommendation': 'Moja rekomendacja',
  'po.withChange': 'Ze zmianą',
  'po.extraRepaymentPerMonth': 'Dodatkowa spłata miesięcznie',
  'po.dragToPayMore': 'Przeciągnij, aby płacić więcej (szybciej bez długów) lub mniej (dłuższy okres)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Zaoszczędzone odsetki',
  'po.overWholeTerm': 'w całym okresie kredytowania',
  'po.netWealthEffect': 'Wpływ na majątek netto',
  'po.becomesYours': 'zostaje u ciebie, a nie w banku',
  'po.interestPostedAs': 'Odsetki i raty tego kredytu są księgowane jako',
  'po.debtJourney': 'Twoja droga do wyjścia z długów',
  'po.debtJourneySub': 'Najważniejsze kamienie milowe na drodze do całkowitego wyjścia z długów',
  'po.yourFinancialFuture': 'Twoja finansowa przyszłość',
  'po.yourFinancialFutureSub': 'Dokąd zaprowadzą cię pieniądze — i jak twoje wybory kształtują tę drogę',
  'po.showingScenario': 'Wyświetlany scenariusz:',
  'po.reset': 'Resetuj',
  'po.desiredNetWealth': 'Docelowy majątek netto',
  'po.lastsUntilYouAre': 'wystarczy do wieku',
  'po.lasts': 'wystarczy',
  'po.forLife': 'do końca życia',
  'po.plummaReadsChart': 'SuperPlumma czyta wykres',
  'po.whatIf': 'Co, jeśli?',
  'po.whatIfSub': 'Ustaw punkt wyjścia w dzisiejszym planie, wybierz decyzję i dostosuj założenia — wykres, cele, daty i emerytura zaktualizują się jednocześnie',
});
